import React, { FC } from 'react';
import { ICategoriesHome3 } from './params';
import Styles from './styles';
import convertToSlug from '../../../utils/convertToSlug';
import { common, routing } from '../../../translates';

const CategoriesHome: FC<{ config: ICategoriesHome3; categories: string[]; language: string }> = ({
  config,
  categories,
  language,
}) => (
  <Styles $config={config}>
    <div className="categories-home">
      <div className="container">
        <h3 className="categories-home-header">{common[language].sectionCategoriesHome}</h3>
        <div className="categories-home-wrapper">
          {categories?.map((category) => (
            <a
              key={category}
              href={`${routing[language].articles}/${convertToSlug(category)}/`}
              className="categories-home-category"
            >
              {category}
            </a>
          ))}
        </div>
      </div>
    </div>
  </Styles>
);

export default CategoriesHome;
